export const GOOGLE_FONTS = [
  'Inter:ital,wght@0,100..900;1,100..900', // Sans-serif
  'Poppins:wght@100..900', // Sans-serif
  'Playfair+Display:wght@400..900', // Serif
  'Roboto+Mono:wght@100..700', // Monospace
  'Space+Grotesk:wght@300..700', // Sans-serif (Modern)
  'Archivo+Black', // Sans-serif (Display Bold)
  'Merriweather:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900', // Serif
  'Caveat:wght@400..700', // Script/Handwriting
  'Oswald:wght@200..700', // Sans-serif (Display Condensed)
  'Lobster', // Script (Display)
];
